/**
 * Per-step state, derived from the step's index relative to the active
 * step (`current`):
 *   - `completed`  index < current  (filled disc + check, navigable back)
 *   - `active`     index === current (filled ring, emphasised label)
 *   - `upcoming`   index > current  (hollow ring, muted, not navigable)
 */
export const STEPPER_STEP_STATE_COMPLETED = 'completed';
export const STEPPER_STEP_STATE_ACTIVE = 'active';
export const STEPPER_STEP_STATE_UPCOMING = 'upcoming';

export type StepperStepState =
  | typeof STEPPER_STEP_STATE_COMPLETED
  | typeof STEPPER_STEP_STATE_ACTIVE
  | typeof STEPPER_STEP_STATE_UPCOMING;

/**
 * Horizontal density. `regular` (default) suits in-dialog wizards;
 * `compact` trims the indicator + type scale for tighter headers.
 */
export const STEPPER_DENSITY_COMPACT = 'compact';
export const STEPPER_DENSITY_REGULAR = 'regular';

export type StepperDensity =
  | typeof STEPPER_DENSITY_COMPACT
  | typeof STEPPER_DENSITY_REGULAR;

export const STEPPER_DENSITY_TOKENS: Record<
  StepperDensity,
  { indicatorSize: string; labelFontSize: string; descriptionFontSize: string; gap: string }
> = {
  [STEPPER_DENSITY_COMPACT]: {
    indicatorSize: '24px',
    labelFontSize: '12.5px',
    descriptionFontSize: '11px',
    gap: '8px',
  },
  [STEPPER_DENSITY_REGULAR]: {
    indicatorSize: '28px',
    labelFontSize: '13.5px',
    descriptionFontSize: '12px',
    gap: '10px',
  },
};
